import config from '@app/config'
import { getCookie } from '@app/services'

export const getB2CUserCurrency = (): string | undefined => {
  return getCookie(config.variables.currency) || undefined
}
